import {subdebug} from '@sanity/cli-core'

export const usersDebug = subdebug('users')
